import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';
import {
  IWhitelistAddEditPayload,
  IGetDataPayload,
} from '@app/dashboard/types/innerLayout/risk_center';

export const getWhitelistData = (data: IGetDataPayload) => {
  const { params, currentPage, pageSize, ...rest } = data;
  const payload = {
    ...rest,
    ...params,
    page: currentPage,
    page_size: pageSize,
  };

  return axiosPrivate.get(`/dashboard/api/v1/risk-center/whitelists`, {
    params: payload,
  });
};

export const addWhiteList = (payload: IWhitelistAddEditPayload) => {
  return axiosPrivate.post(`/dashboard/api/v1/risk-center/whitelists`, payload);
};

export const removeWhiteList = (id: number) => {
  return axiosPrivate.delete(`/dashboard/api/v1/risk-center/whitelists/${id}`);
};

export const editWhiteList = (
  id: number,
  payload: IWhitelistAddEditPayload
) => {
  return axiosPrivate.put(
    `/dashboard/api/v1/risk-center/whitelists/${id}`,
    payload
  );
};
